'use client';
import { Card, CardBody, ScrollShadow } from '@heroui/react';
import { If } from '@uiw/react-only-when';
import { LucideFile, LucideImage, LucideVideo } from 'lucide-react';
import { memo } from 'react';
import MediaPreview from '@/components/ui/media-preview';
import type { Faq } from '@/shared/functions/tanstack-query/get/faqs/get-all-faqs';

export const FaqMedias = memo(({ medias }: { medias: Faq['medias'] }) => {
	if (!medias?.length) return null;
	return (
		<ScrollShadow orientation="horizontal" size={20} className="mt-2 flex w-full gap-4 overflow-x-auto p-1">
			{medias.map((media) => {
				const isVideo = media.mimetype.includes('video/');
				const isPdf = media.mimetype.includes('application/pdf');

				return (
					<Card key={'medias' + media.id} shadow="sm" className="relative w-full max-w-44 shrink-0 rounded-lg bg-background">
						<CardBody className="relative h-44 shrink-0 overflow-hidden">
							<If condition={isVideo}>
								<LucideVideo className="absolute left-2 top-2 z-10 text-success" size={18} />
							</If>
							<If condition={isPdf}>
								<LucideFile className="absolute left-2 top-2 z-10 text-success" size={18} />
							</If>
							<If condition={!isVideo && !isPdf}>
								<LucideImage className="absolute left-2 top-2 z-10 text-success" size={18} />
							</If>

							<MediaPreview media={media} />
						</CardBody>
					</Card>
				);
			})}
		</ScrollShadow>
	);
});
